import type { Permission, SectionPermission } from '@stm/contracts';
import type { TranslationKey } from '@stm/i18n';
import type { NavigationItem } from './routes';

export const navigationGroups: readonly {
  titleKey: TranslationKey;
  permissions: readonly SectionPermission[];
}[] = [
  { titleKey: 'navigation.group.club', permissions: ['athletes.view', 'teams.view'] },
  {
    titleKey: 'navigation.group.activities',
    permissions: ['calendar.view', 'training.view', 'assessments.view', 'competitions.view'],
  },
  {
    titleKey: 'navigation.group.finance',
    permissions: ['billing.view', 'payments.view', 'reports.view'],
  },
  { titleKey: 'navigation.group.administration', permissions: ['settings.view'] },
];

const introductions: Record<SectionPermission, TranslationKey> = {
  'overview.view': 'intro.overview',
  'athletes.view': 'intro.athletes',
  'teams.view': 'intro.teams',
  'calendar.view': 'intro.calendar',
  'training.view': 'intro.training',
  'assessments.view': 'intro.assessments',
  'billing.view': 'intro.billing',
  'payments.view': 'intro.payments',
  'competitions.view': 'intro.competitions',
  'reports.view': 'intro.reports',
  'settings.view': 'intro.settings',
};

/** Guardians keep family-friendly labels; a staff member who is also a guardian keeps staff context. */
export function isFamilyView(permissions: readonly Permission[]): boolean {
  return permissions.includes('children.view') && !permissions.includes('athletes.browse');
}

export function navigationLabel(item: NavigationItem, familyView: boolean): TranslationKey {
  if (familyView && item.permission === 'overview.view') return 'navigation.home';
  if (familyView && item.permission === 'athletes.view') return 'navigation.children';
  return item.labelKey;
}

export function sectionIntroduction(
  permission: SectionPermission,
  familyView = false,
): TranslationKey {
  return familyView && permission === 'athletes.view'
    ? 'intro.children'
    : introductions[permission];
}

/** Detail routes retain their parent section highlight. */
export function isNavigationActive(item: NavigationItem, pathname: string): boolean {
  if (pathname === item.path || pathname.startsWith(`${item.path}/`)) return true;
  return item.permission === 'calendar.view' && pathname.startsWith('/events/');
}
